export default {
      id: "oc-res-vpc-peer-connect-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-vpc-peer-connect",
      toString: function () {
        return this.url;
      }
    }